// src/i18n/errors.ts —— 06 agent-portal A-00「通用错误码 → 文案」（键名对齐 shared/src/errors.ts AGENT_ERRORS）；errRate / errAmount 为原型既有键，不在此
export const I18N_AGENT_ERRORS = {
  zh: {
    err1001: '账号或密码错误',
    err1002: '尝试过于频繁，请 {n} 秒后再试',
    err1005: '该邮箱已被其他账号使用',
    errRateBelowSub: '不能低于该下级已分配给其下级的费率',
    errRateCap: '费率超出平台上限',
    errSubDelBlocked: '该下级存在佣金余额、未结算佣金或在途提佣，暂不可删除',
    noSubTip: '当前账号暂不可新增下级分销商', // 2026-10-18 代理端不展示层级（1305 / can_create_sub=false）
    err1306: '登录账号已存在',
    errWalletUnbound: '未绑定平台用户账号，请联系平台代绑',
    errPriceBelowParent: '售价不能低于上级售价 {parent_eff}', // 1310（0045，A-10 保存）
    errMinWd: '最低提佣金额为 {min} USDT', // 对客评审 2026-10-15 #26：佣金单位 USDT
    errWdPlatformAddr: '不能提现到平台地址',
    errWdChannelMaint: '提现通道维护中，请稍后再试',
    errNoPerm: '无权限执行该操作',
    err1503: '该功能已关闭或系统维护中',
    errExportLimit: '导出行数超过 5000，请缩小筛选范围后重试',
    toastNetwork: '网络异常，请稍后重试', // 本计划定稿（TD-839 代理端网络错误键）
  },
  en: {
    err1001: 'Incorrect account or password',
    err1002: 'Too many attempts. Retry in {n}s',
    err1005: 'Email already in use',
    errRateBelowSub: 'Cannot go below the rate this sub-agent has given to its own sub-agents',
    errRateCap: 'Rate exceeds the platform cap',
    errSubDelBlocked: 'This sub-agent has balance, unsettled or in-flight withdrawals',
    noSubTip: 'This account cannot add sub-agents at the moment',
    err1306: 'Login account already exists',
    errWalletUnbound: 'No platform account bound; contact support',
    errPriceBelowParent: "Price cannot be lower than your upline's price {parent_eff}",
    errMinWd: 'Minimum withdrawal is {min} USDT',
    errWdPlatformAddr: 'Withdrawals to platform addresses are not allowed',
    errWdChannelMaint: 'Withdrawals are under maintenance. Please try again later',
    errNoPerm: "You don't have permission for this action",
    err1503: 'Feature disabled or under maintenance',
    errExportLimit: 'Export exceeds 5,000 rows. Narrow the filters and retry.',
    toastNetwork: 'Network error. Please retry', // 本计划定稿
  },
} as const;
